import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { VesselTypePayload, VesselTypeResponse } from "@/types/interface/vessel-type";

export const useVesselType = defineStore("vesselTypeStore", () => {
  const vesselType = ref<VesselTypeResponse>();
  const vesselTypes = ref<VesselTypeResponse[]>([]);

  function initVesselTypes(data: any) {
    vesselTypes.value = data?.data;
  }

  function addNewVesselType(data: any) {
    vesselType.value = data;
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselType.getVesselType(page, limit, queryParam);
      if (status === 200 ) {
        initVesselTypes(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idVeselType = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselType.findVesselType(idVeselType);
      if (status === 200 ) {
        addNewVesselType(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: VesselTypePayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselType.createVesselType(payload);
      if (status === 200 ) {
        addNewVesselType(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idVeselType = "", payload: VesselTypePayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselType.updateVesselType(idVeselType, payload);
      if (status === 200 ) {
        addNewVesselType(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idVeselType = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vesselType.deleteVesselType(idVeselType);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    vesselType,
    vesselTypes,
    initVesselTypes,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});